import type IItem from "@/managers/data/base/iItem"

export function flatten<T>(array: T[][]): T[] {
	return array.reduce((acc, val) => acc.concat(val), [])
}

export function firstOrNull<T>(array: T[], check: (item: T) => boolean): T | null {
	for (const item of array)
		if (check(item))
			return item
	return null
}

export function removeNullItems<T>(array: Array<T | null>): T[] {
	return array.filter(item => item !== null) as T[]
}

export function toItemMap<T extends IItem>(array: T[]): Map<T["id"], T> {
	return new Map(array.map(i => [i.id, i]))
}

export function getHighestCountValue<T, K extends string & keyof T>(array: T[], key: K): T[K] | null {
	const counts = new Map<T[K], number>()
	array.forEach(item => {
		counts.set(item[key], (counts.get(item[key]) ?? 0) + 1)
	})
	let highestCount = 0
	let highestValue: T[K] | null = null

	counts.forEach((count, value) => {
		if (count > highestCount) {
			highestCount = count
			highestValue = value
		}
	})

	return highestValue
}
